/**
 * Time Grid Header
 *
 * Header row with day names/dates above the time columns.
 */

import { format, isToday } from 'date-fns';
import { it } from 'date-fns/locale';
import clsx from 'clsx';

interface TimeGridHeaderProps {
  days: Date[];
}

export function TimeGridHeader({ days }: TimeGridHeaderProps) {
  return (
    <div className="flex border-b border-border-primary">
      {/* Gutter spacer */}
      <div className="w-14 shrink-0 border-r border-border-primary" />

      {/* Day columns */}
      {days.map((day) => {
        const today = isToday(day);
        return (
          <div
            key={day.toISOString()}
            className={clsx(
              'flex-1 px-2 py-2 text-center border-r border-border-primary last:border-r-0',
              today && 'bg-accent-violet/5'
            )}
          >
            <div className="text-[10px] text-text-tertiary uppercase">
              {format(day, 'EEE', { locale: it })}
            </div>
            <div
              className={clsx(
                'text-base font-semibold mt-0.5',
                today
                  ? 'text-white bg-accent-violet w-7 h-7 rounded-full flex items-center justify-center mx-auto'
                  : 'text-text-primary'
              )}
            >
              {format(day, 'd')}
            </div>
          </div>
        );
      })}
    </div>
  );
}
